import { useMutation } from 'react-query';
import { shallow } from 'zustand/shallow';
import { getTiktokConfig } from '../../../../../../api/services/mediaPlanning/touchpointConfigs';
import usePlanStore from '../../../../../../store/planStore';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';
import { TiktokTargetGroup } from '../interfaces';

const useTiktokConfig = () => {
  const {
    selectedCountry,
    selectedCountryISOCode,
    countryForms,
    generalInfoState,
    updateTikTokConfig,
  } = usePlanStore();

  const { showError } = useError();

  const selectedCountryForm = countryForms[selectedCountry!];
  const tiktokConfig = selectedCountryForm?.tiktokConfig;

  const selectedCountryFormSubset = usePlanStore((state) => {
    const form = state.savedCountryForms[state.selectedCountry!];
    return form
      ? {
          targetGroup: form.targetGroup,
          campaignScenario: form.campaignScenario,
          segments: form.segments,
          startDate: form.startDate,
          campaignLength: form.campaignLength,
          isCountrySetupConfirmed: form.isCountrySetupConfirmed,
        }
      : null;
  }, shallow);

  const {
    mutate: fetchTiktokConfig,
    isLoading,
    data,
  } = useMutation({
    mutationFn: (tiktokTargetGroup?: TiktokTargetGroup) => {
      if (
        !generalInfoState.division ||
        !selectedCountry ||
        !selectedCountryISOCode ||
        !countryForms[selectedCountry]?.campaignScenario
      ) {
        return Promise.reject(
          new Error('Missing required parameters for TikTok config.')
        );
      }

      return getTiktokConfig(
        generalInfoState.division,
        selectedCountryISOCode,
        countryForms[selectedCountry].targetGroup,
        countryForms[selectedCountry].campaignScenario,
        tiktokConfig?.targetGroup?.targetGroup
      );
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || error.message || 'Unknown error';
      showError(errorMessage);
    },
    onSuccess: (response, tiktokTargetGroup) => {
      if (selectedCountry) {
        updateTikTokConfig(selectedCountry, {
          saturation: response?.data?.saturationDefault,
          targetGroup: response.data.targetGroups?.find(
            (targetGroup) =>
              targetGroup.targetGroup ===
              (tiktokTargetGroup?.targetGroup ??
                response.data.recommendedTargetGroup)
          ),
          partners: [],
          partnerBudgetShare: 0,
          saturationMin: response?.data?.saturationMin ?? null,
          saturationMax: response?.data?.saturationMax ?? null,
          targetGroups: response.data.targetGroups ?? [],
          recommendedTargetGroup: response.data.recommendedTargetGroup,
        });
      }
    },
  });

  return {
    fetchTiktokConfig,
    isFetching: isLoading,
    data,
  };
};

export default useTiktokConfig;
